import React, { createContext, useContext, useEffect, useState } from 'react';
import api, { formatApiError } from '../lib/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // user: null = checking, false = anonymous, object = logged in
  const [user, setUser] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/api/auth/me');
        setUser(data);
      } catch {
        setUser(false);
      }
    })();
  }, []);

  const login = async (email, password, role) => {
    try {
      const { data } = await api.post('/api/auth/login', { email, password, role });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post('/api/auth/register', { name, email, password });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = async () => {
    try { await api.post('/api/auth/logout'); } catch {}
    setUser(false);
  };

  const changeAdminCreds = async (newEmail, newPassword) => {
    try {
      const { data } = await api.post('/api/auth/change-admin-creds', {
        email: newEmail, password: newPassword,
      });
      setUser((u) => (u && u.role === 'admin' ? { ...u, email: data.email } : u));
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, changeAdminCreds }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
